import { EmployeeModel } from '../../../../model/employee.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const RequestAction = createAction('[New Employee view overview] get data', props<{ search: string, page: number }>());
export const ResponseAction = createAction('[New Employee view overview] set data', props<{ payload: EmployeeModel[] }>());

export const LoadMoreAction = createAction('[New Employee view overview] load more');
